/** The languages line on a talent card ("Speaks English, Spanish"), the same on the network and the shortlist. */
export default function speaksLabel(languages?: string[] | null): string {
  return `Speaks ${Array.isArray(languages) && languages.length ? languages.join(", ") : "-"}`;
}
